import ObjectsAPI from '../api/Objects';
import PropertyApi from '../api/Property';
import CalendarsAPI from '../api/Calendars';
import * as ObjectConst from '../constants/Property';
import * as ActionTypes from '../constants/ActionTypes';
import * as AppConst from "../constants/App";

export const getObjectById = (id, embed) => dispatch => {
    return PropertyApi.getProperty(id, embed)
        .then(({data}) => {
            dispatch({
                type: ActionTypes.GET_OBJECT_BY_ID,
                payload: data
            });
        });
};

export const setYouWillAlsoLike = (type) => dispatch => {
    const requestParams = {
        type: type,
        embed: [ObjectConst.EMBED.IMAGES, ObjectConst.EMBED.TRANSLATES],
        order: 'CREATE_TIME'
    };

    ObjectsAPI.getObjects(requestParams)
        .then(({data: {rows}}) => {
            dispatch({
                type: ActionTypes.SET_YOU_WILL_ALSO_LIKE,
                payload: rows
            });
        });
};

export const setDateStart = dateStartMoment => ({
    type: ActionTypes.SET_DATE_START_OBJECT,
    payload: dateStartMoment
});

export const setDateEnd = dateEndMoment => ({
    type: ActionTypes.SET_DATE_END_OBJECT,
    payload: dateEndMoment
});

export const bookingCalculate = (objectId, rentCalculationCommand, getCancel) => dispatch => {
    CalendarsAPI.bookingCalculate(objectId, rentCalculationCommand, getCancel)
        .then((request) => {
            dispatch({
                type: ActionTypes.BOOKING_CALCULATE,
                payload: request.data
            });
        });
};

export const getCalendars = (objectId, search) => dispatch => {
    CalendarsAPI.getCalendars(objectId, search)
        .then(({data}) => {
            dispatch({
                type: ActionTypes.GET_CALENDARS,
                payload: data
            });
        });
};

export const addCalendars = (objectId, search) => dispatch => {
    dispatch({
        type: ActionTypes.SET_IS_SHOW_CALENDAR_LOADING,
        payload: true
    });

    CalendarsAPI.getCalendars(objectId, search)
        .then(({data}) => {
            dispatch({
                type: ActionTypes.ADD_CALENDARS,
                payload: data
            });
        });
};

export const setShowOriginal = isShowOriginal => ({
    type: ActionTypes.SET_SHOW_ORIGINAL,
    payload: isShowOriginal
});

export const booking = (propertyId, bookingRequestParams) => dispatch => {
    dispatch({
        type: ActionTypes.PROPERTY_CHANGE_BACKGROUND_LOADING,
        payload: true
    });

    return ObjectsAPI.bookingRequest(
        propertyId,
        bookingRequestParams
    ).then(response => {
        return response.data.sessionId;
    }).catch(e => {
        dispatch({
            type: ActionTypes.PROPERTY_CHANGE_BACKGROUND_LOADING,
            payload: false
        });

    });
};


// WEBPACK FOOTER //
// ./src/actions/ObjectPage.js